// extracted by mini-css-extract-plugin
var _1 = "RentalPortalViewingProfileOutcome-modulebody__cFyeP";
var _2 = "RentalPortalViewingProfileOutcome-modulehead__IlFxi";
export { _1 as "body", _2 as "head" }
